import { htmlToText } from "lib/html-to-text"

export function fullTrim(value) {
    return htmlToText(value).trim()
}
